angular
    .module('fundersclub.funds')
    .config(function($animateProvider: any) {
        // Only enable Angular Animate on certain elements.
        $animateProvider.classNameFilter(/ng-animate-enabled/);
    });
